export const SHOW_TOAST_MESSAGE = 'toast/SHOW_TOAST_MESSAGE';
export const HIDE_TOAST_MESSAGE = 'toast/HIDE_TOAST_MESSAGE';
export const HIDE_AUTO_TOAST_MESSAGE = 'toast/HIDE_AUTO_TOAST_MESSAGE';

const initialState = {
    showToast: false,
    toastMessage: ''
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SHOW_TOAST_MESSAGE:
            return {
                ...state,
                showToast: true,
                toastMessage: action.message
            };
        case HIDE_TOAST_MESSAGE:
            return {
                ...state,
                showToast: false,
                toastMessage: ''
            };
        case HIDE_AUTO_TOAST_MESSAGE:
            if(state.showToast){
                return {
                    ...state,
                    showToast: false,
                    toastMessage: ''
                };
            }
        default:
            return state
    }
}

export const showToastMessage = (message) => {
    return dispatch => {
        dispatch({
            type: SHOW_TOAST_MESSAGE,
            message: message
        });

        return setTimeout(() => {
            dispatch({
                type: HIDE_AUTO_TOAST_MESSAGE
            })
        }, 3000)
    }
};

export const hideToastMessage = () => {
    return dispatch => {
        dispatch({
            type: HIDE_TOAST_MESSAGE
        });
    }
};